import { resources } from "@constants/hardcoded-strings";
import { SKIP_REVIEW_EMAILS_PREFERENCE_NAME } from "@constants/user-preferences";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { AxnAdminUserPreference } from "@idw-types/data/axn-admin-user/axn-admin-user-preference";
import { isNullOrUndefined } from "@utils/object-util";
import { useMemo, useState } from "react";

type OrganizationUserDetailsPreferenceContainerProps = {
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    axnAdminUserState: AxnAdminUser;
    setAxnAdminUserState: (axnAdminUser: AxnAdminUser) => void;
};

export const OrganizationUserDetailsPreferenceContainer = (props: OrganizationUserDetailsPreferenceContainerProps) => {
    const {
        isDisabled,
        labelWidth,
        axnAdminUserState,
        setAxnAdminUserState
    } = props;

    const optInCheckedInitialState = useMemo(() => {
        const skipReviewEmailsPreference = axnAdminUserState.axnAdminUserPreferences?.find(preference => preference?.name === SKIP_REVIEW_EMAILS_PREFERENCE_NAME);
        if (!isNullOrUndefined(skipReviewEmailsPreference)) {
            return skipReviewEmailsPreference.value === 'false';
        }

        const skipReviewEmailsProperty = axnAdminUserState.axnAdminUserProperties.find(property => property.propertyName === SKIP_REVIEW_EMAILS_PREFERENCE_NAME);
        return skipReviewEmailsProperty?.propertyValue === 'false' || false;
    }, [axnAdminUserState.axnAdminUserPreferences, axnAdminUserState.axnAdminUserProperties]);

    const [optInChecked, setOptInChecked] = useState<boolean>(optInCheckedInitialState);

    const handleSkipReviewPreferenceChange = () => {
        const newUserPreference: AxnAdminUserPreference = {
            name: SKIP_REVIEW_EMAILS_PREFERENCE_NAME,
            value: optInChecked ? 'true' : 'false',
            userID: null,
            id: null,
            relyingPartyID: null
        };

        const updatedPreferences = axnAdminUserState.axnAdminUserPreferences?.filter(
            preference => preference.name !== SKIP_REVIEW_EMAILS_PREFERENCE_NAME
        ) || [];

        setAxnAdminUserState({
            ...axnAdminUserState,
            axnAdminUserPreferences: [...updatedPreferences, newUserPreference]
        });

        setOptInChecked(!optInChecked);
    };

    const detailsResources = resources.pages.organizationUserDetails.tabs.details;

    return (
        <div>

            <ContentPageHeader title={detailsResources.preferences.title} />
            <ContentPageBody isMaxWidth={true}>
                <ToggleFormGroup
                    controlId="organization-user-opt-in-radio"
                    automationId="organization-user-opt-in-radio"
                    label={detailsResources.preferences.inputs.label}
                    ariaLabel={detailsResources.preferences.inputs.label}
                    value={`${optInChecked}`}
                    disabled={isDisabled}
                    isRequired={false}
                    labelWidth={labelWidth}
                    onChange={handleSkipReviewPreferenceChange}
                    checked={optInChecked}
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </ContentPageBody>
        </div>
    );
};